import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useImperativeHandle } from 'react';
import { InputAdornment, TextField, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { SearchNormal1 } from 'iconsax-react';
const StyledSearchInput = forwardRef(({ autoFocus = false, fullWidth = false, bordered = true, value, onChange, onKeyDown, handleResetCallback, onClick, sx, readOnly = false }, ref) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isBelow1200 = useMediaQuery(theme.breakpoints.down(1201));
    // Internal ref for the input element
    const inputRef = React.useRef(null);
    // Expose the input element to parent components via ref
    useImperativeHandle(ref, () => inputRef.current);
    React.useEffect(() => {
        if (autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus]);
    return (_jsx(TextField, { inputRef: inputRef, variant: 'outlined', placeholder: `${t('placeholders.search')}...`, size: 'small', value: value, onChange: onChange, onKeyDown: onKeyDown, onClick: onClick, sx: {
            width: fullWidth ? '100%' : 320,
            justifyContent: 'center',
            cursor: readOnly ? 'pointer' : undefined,
            '& input': {
                cursor: readOnly ? 'pointer' : undefined
            },
            '& input:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px transparent inset !important',
                WebkitTextFillColor: 'inherit',
                backgroundColor: 'transparent !important',
                transition: 'background-color 5000s ease-in-out 0s'
            },
            '& .MuiInputBase-root': {
                background: theme.palette.background.paper,
                height: 40,
                '&::placeholder': {
                    color: (theme) => `${theme.palette.grey[400]} !important`,
                    ...theme.typography.body2
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    border: bordered ? 'auto' : 'none'
                }
            },
            ...(typeof sx === 'object' ? sx : {})
        }, inputProps: {
            readOnly: readOnly
        }, slotProps: {
            input: {
                sx: {
                    ...theme.typography.body2
                },
                startAdornment: (_jsx(InputAdornment, { position: 'start', children: _jsx(SearchNormal1, { variant: 'Outline', color: theme.palette.grey[400] }) })),
                endAdornment: !isBelow1200 && value && value.length > 0 ? (_jsx(InputAdornment, { position: 'end', onClick: handleResetCallback, sx: { cursor: 'pointer' }, children: _jsx(Icon, { icon: 'eva:close-fill', width: '24', height: '24', color: theme.palette.text.disabled }) })) : (_jsx(_Fragment, {}))
            }
        } }));
});
StyledSearchInput.displayName = 'StyledSearchInput';
export default StyledSearchInput;
